export default __webpack_public_path__ + "static/media/home-page-header.0d9b43e3.jpg";